
import Swiper from 'vux/src/components/swiper/swiper.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {DownLoadPageApi} from '@/api'
import Common from '@/common/js/common';
import wechatUtil from '@/common/js/wechatUtil'
import mixin from '@/mixins'

export default {
mixins: [mixin],
name: "Download",
data() {
return {
id: "",
showTips: false,
swiperHeight: document.documentElement.clientWidth * 0.72 / 9 * 16 + 'px',
swiperWidth: document.documentElement.clientWidth * 0.72 + 'px',
myWxAppId: "",
myNonceStr: "",
mySignature: "",
myTimestamp: "",
downLoadInfo: {},
downLoadPageImgList: [],
myShareContent: "",
myShareImage: "",
myShareTitle: "",
swiperItemIndex: 0
}
},
components: {
Swiper,
SwiperItem,
GroupTitle,
XButton,
Divider
},
created: function () {
var _hmt = _hmt || [];
(function() {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?ba61eb220aae6aedcaada1eee60b0736";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();
this.id = this.$route.query.id
this.loadData()
},
methods: {
loadData() {
this.getInfo()
},
getInfo() {
DownLoadPageApi.getDownLoadList({id: this.id}).then(data => {
if (data.Status === 200) {
this.downLoadInfo = data.Result;
this.downLoadPageImgList = data.Result.ImageList;
this.myShareContent = data.Result.ShareContent;
this.myShareImage = data.Result.ShareImage;
this.myShareTitle = data.Result.ShareTitle;
document.title = data.Result.Title
this.initWeChat()
}
})
},
initWeChat() {
const that = this
if (Common.isWeiXin) {
wechatUtil.initWechatConfig(that.$wechat, [
'onMenuShareTimeline',
'onMenuShareAppMessage'
], function () {
wechatUtil.shareConfig(that.$wechat, {
sTitle: that.myShareTitle,
sDesc: that.myShareContent,
sLink: window.location.href,
sImgurl: that.myShareImage
});
})
}
},
goDownLoad() {
if (Common.isIOS) {
this.$vux.toast.text('非常抱歉，当前应用仅支持安卓手机，\n' +
'苹果手机暂时无法安装应用，\n' +
'敬请期待！', 'center');
} else {
if (Common.isAndroid && Common.isWeiXin) {
this.showTips = true
} else {
window.location.href = this.downLoadInfo.AndroidUrl;
}
}
},
onSwiperItemIndexChange(index) {
this.swiperItemIndex = index;
},
swiperLeft() {
this.swiperItemIndex--;
},
swiperRight() {
this.swiperItemIndex++;
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Download.vue